import React, { useState } from "react";

const faqs = [
  {
    question: "What do I need to know before contacting you?",
    answer:
      "You should have a basic idea about your project requirements, timeline, and budget. This helps us understand your needs better and suggest the right solution.",
  },
  {
    question: "Do you have any reviews from satisfied customers?",
    answer:
      "Yes, we have testimonials from our clients and students who have successfully completed projects and secured placements.",
  },
  {
    question: "How much time will it take for you to make my app?",
    answer:
      "The development timeline depends on project complexity. Small projects may take 2–4 weeks, while larger applications may take longer.",
  },
  {
    question: "How do you guarantee product quality?",
    answer:
      "We follow industry best practices, regular testing, code reviews, and client feedback cycles to ensure high-quality delivery.",
  },
  {
    question: "Should I create a mobile or a web app?",
    answer:
      "This depends on your target audience and business goals. We help you choose the best option based on your requirements.",
  },
  {
    question: "What happens after you finish my app?",
    answer:
      "After delivery, we provide deployment support, documentation, and post-launch maintenance if required.",
  },
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="bg-gradient-to-br from-gray-500 via-gray-600 to-gray-500 py-20 text-gray-900">
      <div className="max-w-7xl mx-auto px-6">

        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4 text-gray-200">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-300 max-w-3xl mx-auto">
            We hope this section will help you better understand common questions related to our services.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {faqs.map((faq, index) => (
            <div
              key={index}
              onClick={() => toggleFAQ(index)}
              className={`cursor-pointer rounded-2xl p-6 transition-all duration-300
                bg-white border border-gray-200 shadow-sm
                hover:shadow-lg hover:border-indigo-300
                ${activeIndex === index ? "ring-2 ring-indigo-500" : ""}
              `}
            >
              <div className="flex justify-between items-center">
                <h4 className="font-semibold text-lg text-gray-800">
                  {faq.question}
                </h4>
                <span className="text-2xl font-bold text-indigo-600">
                  {activeIndex === index ? "−" : "+"}
                </span>
              </div>

              <div
                className={`grid transition-all duration-300 ease-in-out
                  ${activeIndex === index ? "grid-rows-[1fr] mt-4" : "grid-rows-[0fr]"}
                `}
              >
                <p className="overflow-hidden text-gray-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default FAQ;
